import { getLimiter } from "./../instance.js";
import {getFullTokenInfo} from './fetchMetaData.js';
export async function fetchMetaData(mint:any){
  return await getFullTokenInfo(mint);
}
export async function fetchUmi(){
  return await getLimiter().fetchUmi();
}
